<template>
  <!-- Positive percentage -->
  <div v-if="props.percentage > 0" class=" w-full bg-green-100 w-full rounded-full">
    <div class="flex flex-row justify-between items-baseline px-1.5 pt-3 w-full rounded-full text-sm font-medium  text-green-800">
      <!-- Heroicon name: solid/arrow-sm-up -->
      <svg class=" -mt-3 flex-shrink-0 self-center h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
      </svg>
      <div class="-mt-3">{{percentageWritten}}</div>
    </div>
  </div>
  <!-- Negative percentage -->
  <div v-else-if="props.percentage < 0" class=" w-full bg-red-100 w-full rounded-full">
    <div class=" flex flex-row justify-between items-baseline px-1.5 pt-3 w-full rounded-full text-sm font-medium  text-red-800">
      <!-- Heroicon name: solid/arrow-sm-up -->

      <svg class=" -mt-3 flex-shrink-0 self-center h-5 w-5 text-red-500"
           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd"
              d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
              clip-rule="evenodd"/>
      </svg>

      <div class="-mt-3">{{percentageWritten}}</div>
    </div>
  </div>
  <!-- Neutral percentage -->
  <div v-else class=" pl-0.5 w-full bg-gray-100 w-full rounded-full">
    <div class="flex flex-row justify-between items-baseline px-1.5 pt-3 w-full rounded-full text-sm font-medium  text-gray-500">

      <svg class=" -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
              d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
              clip-rule="evenodd"/>
      </svg>
      <svg class="-ml-4 mr-1 -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500"
           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
              d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
              clip-rule="evenodd"/>
      </svg>

      <div class="-mt-2.5">{{percentageWritten}}</div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import {useApiStore} from "@/stores/ApiStore";
const apiDataStore = useApiStore()

let props = defineProps( {
  percentage: Number
})
let percentageWritten = ref();

onMounted(()=> {

  if (props.percentage < 0){
    percentageWritten.value = formatter.format((props.percentage * -1));
  }else if(props.percentage >= 1){
    percentageWritten.value = formatterLarge.format(props.percentage );
  } else{
    percentageWritten.value = formatter.format(props.percentage );
  }

})


let option = ref({
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const formatter = new Intl.NumberFormat(apiDataStore.getLang, option.value);
let optionLarge = ref({
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
const formatterLarge = new Intl.NumberFormat(apiDataStore.getLang, optionLarge.value);
</script>
